module.exports = __webpack_public_path__ + "img/Aleksandra-Kuncewicz.8449dae5.jpg";